import { Dispatch, SetStateAction, useCallback } from 'react';

interface IProps {
  pageSize: number;
  pageNumber: number;
  setPageNumber: Dispatch<SetStateAction<number>>;
  totalItems: number;
}

const Paginator = ({
  pageNumber,
  pageSize,
  setPageNumber,
  totalItems,
}: IProps) => {
  const totalPages = Math.ceil(totalItems / pageSize);

  const getPageIndicators = useCallback(() => {
    const totalPages = Math.ceil(totalItems / pageSize);
    const bottom = pageNumber - 4;
    let start = bottom < 1 ? 1 : bottom;
    const end = start + 8;
    const arr = [];

    while (start <= end) {
      if (start <= totalPages) arr.push(start);
      ++start;
    }

    return (
      <>
        {!arr.includes(2) && totalPages > 9 && (
          <>
            <li>
              <a
                href="/"
                onClick={ev => {
                  ev.preventDefault();
                  setPageNumber(1);
                }}
              >
                1
              </a>
            </li>
            <li className="disabled">
              <a href="/" onClick={e => e.preventDefault()}>
                ...
              </a>
            </li>
          </>
        )}
        {arr.map(display => (
          <li key={display} className={display === pageNumber ? 'active' : ''}>
            <a
              href="/"
              onClick={ev => {
                ev.preventDefault();
                setPageNumber(display);
              }}
            >
              {display}
            </a>
          </li>
        ))}
        {!arr.includes(totalPages - 1) && totalPages > 9 && (
          <>
            <li className="disabled">
              <a href="/" onClick={e => e.preventDefault()}>
                ...
              </a>
            </li>
            <li>
              <a
                href="/"
                onClick={ev => {
                  ev.preventDefault();
                  setPageNumber(totalPages);
                }}
              >
                {totalPages}
              </a>
            </li>
          </>
        )}
      </>
    );
  }, [totalItems, pageSize, pageNumber, setPageNumber]);

  if (!totalItems) return;

  return (
    <ul className="pagination center">
      <li className={pageNumber === 1 ? 'disabled' : ''}>
        <a href="/">
          <i
            className="material-icons"
            onClick={ev => {
              ev.preventDefault();
              if (pageNumber !== 1) setPageNumber(prev => prev - 1);
            }}
          >
            chevron_left
          </i>
        </a>
      </li>
      {getPageIndicators() ?? null}
      <li className={pageNumber === totalPages ? 'disabled' : ''}>
        <a href="/">
          <i
            className="material-icons"
            onClick={ev => {
              ev.preventDefault();
              if (pageNumber !== totalPages) setPageNumber(prev => prev + 1);
            }}
          >
            chevron_right
          </i>
        </a>
      </li>
    </ul>
  );
};

export default Paginator;
